"use client";

import GameThumb from "@casino/client/components/GameCard/GameThumb";
import Link from "@casino/client/components/Link";
import desktopMediaQuery from "@casino/ui/Games/desktopMediaQuery";
import {
  GameHorizontalPreviewCard,
  useMediaQuery,
} from "@workspace/frontend-ui";
import type { FC } from "react";

type Props = {
  game: GameFragment;
  // The server's UA guess only seeds the first paint; the media query takes over from mount on.
  isMobile?: boolean;
  isWebComponentGame?: boolean;
};

const ReleatedGamesItem: FC<Props> = ({
  game,
  isMobile,
  isWebComponentGame,
}) => {
  const isRail = useMediaQuery(
    isWebComponentGame ? "(min-width: 1513px)" : desktopMediaQuery,
    !isMobile,
  );

  if (!isRail) {
    return (
      <div className="w-[115px] shrink-0">
        <GameThumb game={game} />
      </div>
    );
  }

  if (!game.href) {
    return <GameHorizontalPreviewCard game={game} rtp={game.rtp} />;
  }

  return (
    <Link
      href={game.href}
      prefetch={false}
      className="block transition-opacity hover:opacity-80"
    >
      <GameHorizontalPreviewCard game={game} rtp={game.rtp} />
    </Link>
  );
};

export default ReleatedGamesItem;
